// BLOG TAB ACTIVE JS
jQuery(function($) {
     var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
     $('.blog_list_nav_link a').each(function() {             
        if (this.href === path) {              
         $('.blog_list_nav_link').removeClass('blog_nav_active');  
         $(this).parent().addClass('blog_nav_active');
        }
     });
});